export enum PlaceChangeAsWork {
  No = 0,
  Always = 1,
  OnlyNotManual = 2,
  SkipFerryTrain = 3,
}
